import { LocationOption } from '../types/Location';
import { getApiHeaders } from '../utils/apiHeaders';

const API_BASE_URL = process.env.REACT_APP_TRAVEL_API_BASE_URL

export function loadLocations(inputValue: string): Promise<LocationOption[]>;

export function loadLocations(
  inputValue: string,
  callback: (options: LocationOption[]) => void
): void;

export function loadLocations(
  inputValue: string,
  callback?: (options: LocationOption[]) => void
): Promise<LocationOption[]> | void {
  if (!inputValue || inputValue.length < 3) {
    if (callback) {
      callback([]);
      return;
    }
    return Promise.resolve([]);
  }

  const url = `${API_BASE_URL}/locations?search=${encodeURIComponent(inputValue)}`;
  const promise = fetch(url, {
    headers: getApiHeaders('none')
  })
    .then(res => {
      if (!res.ok) throw new Error('Failed to fetch locations');
      return res.json() as Promise<LocationOption[]>;
    });

  if (callback) {
    promise.then(data => callback(data)).catch(() => callback([]));
    return;
  }

  return promise;
}

export function loadAirportLocations(inputValue: string): Promise<LocationOption[]>;
export function loadAirportLocations(
  inputValue: string,
  callback: (options: LocationOption[]) => void
): void;
export function loadAirportLocations(
  inputValue: string,
  callback?: (options: LocationOption[]) => void
): Promise<LocationOption[]> | void {
  if (callback) {
    loadLocations(inputValue, (opts) => {
      const filtered = opts.filter(o => o.type === 'airport');
      callback(filtered);
    });
    return;
  }
  return loadLocations(inputValue).then(opts =>
    opts.filter(o => o.type === 'airport')
  );
}

export function loadCityLocations(inputValue: string): Promise<LocationOption[]>;
export function loadCityLocations(
  inputValue: string,
  callback: (options: LocationOption[]) => void
): void;
export function loadCityLocations(
  inputValue: string,
  callback?: (options: LocationOption[]) => void
): Promise<LocationOption[]> | void {
  if (callback) {
    loadLocations(inputValue, (opts) => {
      const filtered = opts.filter(o => o.type === 'city');
      callback(filtered);
    });
    return;
  }
  return loadLocations(inputValue).then(opts =>
    opts.filter(o => o.type === 'city')
  );
}
